import axios from "axios";
import { API_END_POINT } from "../../../../config";
import { startSpinner, stopSpinner } from "../../../shared-components/custom-spinner/custom-spinner-store/spinner-actions";
import { loadToaster } from "../../../shared-components/toaster/toaster-actions-creators";
import { fetchDashboard } from "./dashboard-actions-creators";

export const fetchDashboardData = (surveyId) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const { data } = await axios.get(
        `${API_END_POINT.BASE_URL}/api/Dashboard/GetSurvey_Dashboard/${surveyId}`
      );
      console.log(data)
      dispatch(fetchDashboard(data));

      dispatch(stopSpinner());
      return data; // Return for component use
    } catch (err) {
      dispatch(stopSpinner());
      dispatch(
        loadToaster({
          type: "error",
          title: "Failed to fetch dashboard data",
          msg: err.message
        })
      );
    }
  };
};
